import { SalePinActions } from '@/pages/sale/components/sale-pin-actions';
import { useSalePins } from '@/pages/sale/context/sale-providers';
import { memo } from 'react';

type SalePinActionsBarProps = {
  pinWrapMode: boolean;
  onPinWrapModeChange: (wrap: boolean) => void;
  onOpenSearch: () => void;
};

/** Isolated pin-actions bar so pin context updates don't re-render the product table sibling. */
export const SalePinActionsBar = memo(function SalePinActionsBar({
  pinWrapMode,
  onPinWrapModeChange,
  onOpenSearch,
}: SalePinActionsBarProps) {
  const { pinnedVariantTabs, handleRefreshPins, handleUnpinAll } = useSalePins();

  return (
    <SalePinActions
      pinnedCount={pinnedVariantTabs.length}
      pinWrapMode={pinWrapMode}
      onPinWrapModeChange={onPinWrapModeChange}
      onRefresh={handleRefreshPins}
      onOpenSearch={onOpenSearch}
      onUnpinAll={handleUnpinAll}
    />
  );
});
